import clsx from "clsx";
import type { CSSProperties } from "react";

import { useGridStore } from "../../store/gridStore";
import { useAutoSubtype } from "../../hooks/useAutoSubtype";
import { useGridMaximize } from "../../hooks/useGridMaximize";
import { GridCell } from "./GridCell";

export function VideoGrid() {
  useAutoSubtype();
  const cells = useGridStore((s) => s.cells);
  const preset = useGridStore((s) => s.preset);
  const { maximizedCellId, onCellDoubleClick } = useGridMaximize();

  const cols = Math.ceil(Math.sqrt(preset));
  const rows = Math.ceil(preset / cols);
  const isMax = maximizedCellId !== null;

  // Renderizamos SIEMPRE todas las celdas en una sola lista (mismo orden, misma
  // posicion en el arbol DOM). Solo cambian estilos:
  //   - sin maximizado: cada celda fluye en el grid normalmente.
  //   - con maximizado: la celda maximizada flota absolute fullscreen,
  //     las demas se ocultan con display:none.
  // Esto evita que React desmonte/remonte los componentes — y por tanto el
  // useWebRTC cleanup no se dispara, los streams MSE no se reinician al
  // maximizar/restaurar.
  const cellStyle = (cellId: string): CSSProperties => {
    if (!isMax) return {};
    if (cellId === maximizedCellId) {
      return { position: "absolute", inset: 0, zIndex: 10 };
    }
    return { display: "none" };
  };

  return (
    <div
      className={clsx(
        "w-full h-full bg-bg",
        isMax ? "relative" : "grid gap-0.5 p-0.5",
      )}
      style={isMax ? undefined : {
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
      }}
    >
      {cells.map((c) => (
        <div key={c.cellId} className="w-full h-full" style={cellStyle(c.cellId)}>
          <GridCell cell={c} onMaximize={() => onCellDoubleClick(c.cellId)} />
        </div>
      ))}
    </div>
  );
}
